import { defineAppPlugin } from '@/main';
import isFunction from '@/utils/isFunction';
import isUndefined from '@/utils/isUndefined';

export default defineAppPlugin(() => {
  // Polyfills for Safari support
  // https://caniuse.com/requestidlecallback
  if (isUndefined(window)) return;
  if (isFunction(window.requestIdleCallback)) return;

  window.requestIdleCallback = cb => {
    const start = Date.now();
    const idleDeadline = {
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
    };

    return window.setTimeout(() => {
      cb(idleDeadline);
    }, 1);
  };

  window.cancelIdleCallback = id => {
    clearTimeout(id);
  };
});
